import { useEffect } from "react";
import classNames from "classnames";
import { ErrorSVG } from "./svg";

export default function OverlayPopup({
  children,
  title,
  size = "sm:max-w-lg",
  useEnter = false,
  noText = "Back",
  yesText = "Save",
  actionOnNo,
  actionOnYes,
  isAlert = false,
  submitting = false,
  layout = "default",
}) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (useEnter && e.key === "Enter") {
        actionOnYes();
      } else if (e.key === "Escape") {
        actionOnNo();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div
      className="relative z-10"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

      <div className="fixed z-10 inset-0 overflow-y-auto">
        <div className="flex items-end sm:items-center justify-center min-h-full p-4 pb-16 text-center sm:p-0">
          <div
            className={classNames(
              "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 w-full",
              size
            )}
          >
            <div className="bg-white px-4 py-5 sm:p-6 sm:pb-4">
              <div className="sm:flex sm:items-start gap-x-4">
                {isAlert && (
                  <div
                    className={classNames(
                      "mx-auto flex-shrink-0 flex items-center justify-center",
                      "h-12 w-12 rounded-full bg-bg-purple sm:mx-0 sm:h-10 sm:w-10 text-light-purple"
                    )}
                  >
                    <ErrorSVG />
                  </div>
                )}
                <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                  <h3
                    className="text-lg leading-6 font-medium text-gray-900"
                    id="modal-title"
                  >
                    {title}
                  </h3>
                  <div className="mt-2 text-sm text-gray-500">{children}</div>
                </div>
              </div>
            </div>
            <div
              className={classNames(
                "bg-gray-50 px-4 py-4 sm:px-6 sm:py-3 sm:flex sm:flex-row-reverse"
              )}
            >
              <button
                type="button"
                className={classNames(
                  "w-full min-w-[95px] inline-flex justify-center rounded-md border border-transparent",
                  "shadow-sm px-4 py-2 bg-light-purple text-base font-medium text-white",
                  "hover:bg-dark-purple focus:outline-none sm:text-sm disabled:bg-disabled-purple",
                  layout === "singleaction" ? "" : "sm:w-auto sm:ml-3"
                )}
                disabled={submitting}
                id="yes-button"
                onClick={async () => {
                  await actionOnYes();
                }}
              >
                {yesText}
              </button>
              {layout === "default" && (
                <button
                  type="button"
                  className={classNames(
                    "mt-3 w-full min-w-[95px] inline-flex justify-center rounded-md border border-gray-300",
                    "shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50",
                    "focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm disabled:bg-gray-2"
                  )}
                  disabled={submitting}
                  id="no-button"
                  onClick={() => {
                    actionOnNo();
                  }}
                >
                  {noText}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
